import { jsx, jsxs } from 'react/jsx-runtime';
import { Flex, themedColor, useAccordion } from '@lemonade-hq/cdk';
import React from 'react';
import styled, { css } from 'styled-components';
import { ToggleArrow } from './ToggleArrow.esm.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  flex: 1;\n  align-items: center;\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  background: transparent;\n  height: 60px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  border: 0;\n  outline: 0;\n  position: relative;\n  cursor: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  flex-grow: 1;\n  text-align: initial;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n      margin-top: 16px;\n      border-top: 1px solid ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  padding: 17px;\n  justify-content: center;\n  margin-top: 0;\n  width: 100%;\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
var AccordionSummaryWrapper = styled(Flex)(_templateObject());
var AccordionHeaderButton = styled(Flex).attrs({
    as: "button",
    type: "button"
})(_templateObject1(), function(param) {
    var disabled = param.disabled;
    return disabled ? "not-allowed" : "pointer";
});
var Left = styled.div(_templateObject2());
var BottomChevronContainer = styled(Flex)(_templateObject4(), function(param) {
    var isOpen = param.isOpen;
    return !isOpen && css(_templateObject3(), themedColor("cloud"));
});
var AccordionSummary = function(_param, ref) {
    var children = _param.children, _param_expandIcon = _param.expandIcon, expandIcon = _param_expandIcon === void 0 ? /*#__PURE__*/ jsx(ToggleArrow, {}) : _param_expandIcon, _param_showExpandIcon = _param.showExpandIcon, showExpandIcon = _param_showExpandIcon === void 0 ? true : _param_showExpandIcon, _param_showBottomExpandIcon = _param.showBottomExpandIcon, showBottomExpandIcon = _param_showBottomExpandIcon === void 0 ? false : _param_showBottomExpandIcon, props = _object_without_properties(_param, [
        "children",
        "expandIcon",
        "showExpandIcon",
        "showBottomExpandIcon"
    ]);
    var _useAccordion = useAccordion(), id = _useAccordion.id, toggle = _useAccordion.toggle, disabled = _useAccordion.disabled, getSummaryProps = _useAccordion.getSummaryProps;
    return /*#__PURE__*/ jsx(AccordionSummaryWrapper, _object_spread_props(_object_spread(_object_spread_props(_object_spread({}, getSummaryProps({
        "data-testid": "".concat(id, "-content")
    })), {
        ref: ref
    }), props), {
        children: /*#__PURE__*/ jsxs(AccordionHeaderButton, _object_spread_props(_object_spread({
            disabled: disabled,
            flexDirection: showBottomExpandIcon ? "column" : "row",
            onClick: toggle
        }, props), {
            children: [
                /*#__PURE__*/ jsx(Left, {
                    children: children
                }),
                showExpandIcon && expandIcon,
                !showExpandIcon && showBottomExpandIcon && /*#__PURE__*/ jsx(BottomChevronContainer, {
                    children: expandIcon
                })
            ]
        }))
    }));
};
var AccordionSummaryWithRef = /*#__PURE__*/ React.forwardRef(AccordionSummary);
var AccordionSummaryWithMemo = /*#__PURE__*/ React.memo(AccordionSummaryWithRef);

export { AccordionHeaderButton, AccordionSummaryWithMemo as AccordionSummary };
